import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  value: 0,
  status: 'idle',
};

export const mailSlice = createSlice({
  name: 'mail',
  initialState: { sendMessageIsOpen: false, selectedMail: null, mailCount: 1 },

  reducers: {
    selectMail: (state, action) => {
      state.selectedMail = action.payload;
    },
    openSendMessage: (state) => {
      state.sendMessageIsOpen = true;
    },
    closeSendMessage: (state) => {
      state.sendMessageIsOpen = false;
    },
    setMailCount: (state, action) => {
      state.mailCount = action.payload;
    },
  },
});

export const { openSendMessage, closeSendMessage, selectMail, setMailCount } =
  mailSlice.actions;

export const selectOpenMail = (state) => {
  return state.mail.selectedMail;
};
export const selectSendMessageIsOpen = (state) => state.mail.sendMessageIsOpen;

export const selectMailCount = (state) => state.mail.mailCount;

export default mailSlice.reducer;
